module.exports = __webpack_public_path__ + "static/Rahnema4-d2e36a86919b1a8eb86f4c2378deb134.jpg";